<div style="box-sizing: border-box; display: flex; flex-direction: column; gap: 20px;" *ngIf="editingFact">
  <div></div>
  <div style="flex-direction: row; box-sizing: border-box; display: flex; gap: 20px;">
    <div></div>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
      <mat-toolbar color="primary" class="toolbar-over-card">
        <div style="box-sizing: border-box; display: flex; place-content: center flex-start; align-items: center;">
          <mat-card-title>Edit Fact</mat-card-title>
        </div>
      </mat-toolbar>
      <div style="display: flex; box-sizing: border-box; flex: 1 1 0%;">
        <mat-card appearance="outlined" style="width: 100%;">
          <mat-card-content style="margin-bottom: 0; display:flex; flex-direction: row;">
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; margin: 20px; justify-content: flex-start">
              <div>
                <div style="box-sizing: border-box; display: flex; place-content: center flex-start; align-items: center;">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Fact Title</mat-label>
                    <input matInput placeholder="Fact Title" [(ngModel)]="editingFact.title" />
                  </mat-form-field>
                </div>
              </div>
              <div>
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Enter a date range</mat-label>
                  <mat-date-range-input [rangePicker]="rangePicker">
                    <input matStartDate placeholder="Start date" [(ngModel)]="editingFact.dateStart">
                    <input matEndDate placeholder="End date" [(ngModel)]="editingFact.dateEnd">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                  <mat-date-range-picker #rangePicker></mat-date-range-picker>
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="full-width" appearance="fill">
                  <mat-label>Contested</mat-label>
                  <mat-select [(ngModel)]="editingFact.contested">
                    <mat-option *ngFor="let contested of contestedList"
                                [value]="contested.value">{{contested.displayText}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="full-width" appearance="fill">
                  <mat-label>Material</mat-label>
                  <mat-select [(ngModel)]="editingFact.material">
                    <mat-option *ngFor="let material of materialList"
                                [value]="material.value">{{material.displayText}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div style="box-sizing: border-box; display: flex; flex: 10 1 0%; flex-direction: column; margin: 20px">
              <div style="display: flex; box-sizing: border-box; flex-direction: column;">
                <div style="display:flex; justify-content:space-between; flex-direction: row; width: 100%;">
                  <div>
                    <mat-label class="title">Linked Issues</mat-label>
                  </div>
                  <div style="box-sizing: border-box; display: flex; justify-content: flex-end; gap: 10px;">
                    <div>
                      <a class="link" [routerLink]="[]" (click)="selectAllIssues()">All</a>
                    </div>
                    <div>
                      <a class="link" [routerLink]="[]" (click)="unSelectAllIssues()">None</a>
                    </div>
                  </div>
                </div>
                <mat-selection-list class="list" style="text-align: left;" [(ngModel)]="editingFact.linkedIssues" [compareWith]="issueComparatorFunction">
                  @for (issue of issues$ | async; track issue) {
                  <mat-list-option [value]="issue">
                    <div style="margin-top:17px;">{{issue.title}}</div>
                  </mat-list-option>
                  }
                </mat-selection-list>
              </div>
            </div>
            <div style="box-sizing: border-box; display: flex; flex: 15 1 0%; flex-direction: row; margin: 20px;">
              <div style="display: flex; box-sizing: border-box; flex-direction: column; width: 100%;">
                <div style="flex-direction: column">
                  <div style="box-sizing: border-box; display: flex; place-content: center flex-start; align-items: center;">
                    <mat-label class="title">Linked Documents</mat-label>
                  </div>
                  <br>
                  <div style="display: flex; gap: 10px; align-items: center;">
                    <div style="flex-grow: 1;">
                      <mat-form-field appearance="fill" style="width: 100%;">
                        <mat-label>Search by document title</mat-label>
                        <input matInput
                               aria-label="State"
                               [matAutocomplete]="auto"
                               [formControl]="formControl">
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWithFn">
                          <mat-option *ngFor="let document of (documents$| async)" [value]="document" style="padding-top: 4px; padding-bottom: 8px; margin: 2px 0;">
                            <div style="display: flex; flex-direction: column; gap: 2px;">
                              <div class="overflow-ellipsis" style="height: 20px; font-size: 14px;">
                                <span>{{document.title}}{{document.extension}}</span>
                              </div>
                              <div *ngIf="document.pageCount > 1" style="font-size: 12px; opacity: 0.7;">
                                <span *ngIf="document.batesStartPageStamp">[{{document.batesStartPageStamp}}]</span>
                                <span *ngIf="document.batesEndPageStamp"> - [{{document.batesEndPageStamp}}]</span>
                                <span *ngIf="document.batesStartPageStamp || document.batesEndPageStamp"> |</span> {{document.pageCount}} pages
                              </div>
                              <div *ngIf="document.pageCount === 1" style="font-size: 12px; opacity: 0.7;">
                                <span *ngIf="document.batesStartPageStamp">[{{document.batesStartPageStamp}}] |</span> {{document.pageCount}} page
                              </div>
                            </div>
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                    </div>
                    <div *ngIf="(document$ | async)?.pageCount > 1">
                      <mat-form-field appearance="fill" style="width: 87px; height: 71px;">
                        <mat-label>Page</mat-label>
                        <mat-select [formControl]="formControlPage">
                          <mat-option *ngFor="let page of (pageCount$ | async)" [value]="page">{{page}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div style="height: 49px;padding-left: 10px;">
                      <button mat-raised-button color="primary" type="submit" (click)="addDocument()">Add</button>
                    </div>
                  </div>
                </div>
                <mat-action-list class="list" style="text-align: left; max-height: 275px; overflow: auto;">
                  <button mat-list-item *ngFor="let linkedDocument of editingFact.linkedDocuments" class="center-list-item-title">
                    <div matListItemTitle>
                      <a href="/review/doc-viewer?DocId={{linkedDocument.documentId}}&p={{linkedDocument.pageNumber}}" target="DocViewer">
                        {{linkedDocument.documentTitle}}
                      </a>
                    </div>
                    <div matListItemMeta (click)="removeDocument(linkedDocument)"><mat-icon>close</mat-icon></div>
                  </button>
                </mat-action-list>
              </div>
            </div>
          </mat-card-content>
          <mat-card-actions style="justify-content: flex-end;">
            <div *inRole="roles.EditFeatureSet" style="box-sizing: border-box; display: flex; place-content: center flex-end; align-items: center; margin-right: 20px;">
              <button mat-button color="primary" type="submit" [disabled]="!editingFact.title" (click)="save()">Save</button>
              <button mat-button color="primary" type="button" (click)="cancel()">Cancel</button>
            </div>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
    <div></div>
  </div>
  <div></div>
</div>